import { render, staticRenderFns } from "./ruleCheckbox.vue?vue&type=template&id=f3a09346"
import script from "./ruleCheckbox.vue?vue&type=script&lang=js"
export * from "./ruleCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports